import TextFormatInputField from './TextFormatInputField'
export * from './TextFormatInputField'
export default TextFormatInputField
